import React, { useState, useEffect } from 'react';

function Level({ timerDuration, onLevelComplete, onLevelFail, children, onTimeUpdate, onScoreUpdate }) {
  const [collectedItems, setCollectedItems] = useState(0);
  const [timer, setTimer] = useState(timerDuration);

  useEffect(() => {
    const interval = setInterval(() => {
      if (timer > 0 && collectedItems !== React.Children.count(children)) {
        setTimer((prevTimer) => {
          const updatedTime = prevTimer - 1;
          onTimeUpdate(updatedTime);
          return updatedTime;
        });
      } else {
        clearInterval(interval);
        if (collectedItems === React.Children.count(children)) {
          onLevelComplete();
        } else {
          onLevelFail();
        }
      }
    }, 1000);

    return () => clearInterval(interval);
  }, [collectedItems, timer, children, onLevelComplete, onLevelFail, onTimeUpdate]);

  
  const handleCollect = () => {
    setCollectedItems((prevCollectedItems) => {
      const newCount = prevCollectedItems + 1;
      onScoreUpdate(newCount);
      return newCount;
    });
  };



  return (
    <group>
      {/* <div>Time Left: {timer}</div> */}
      {React.Children.map(children, (child) => {
        return React.cloneElement(child, { onCollect: handleCollect});
      })}
    </group>
  );
}

export default Level;